import React from 'react';
import { useJijelStore } from '../../../../store/main/modal/usejijelStore';
import { DownloadIcon, X } from 'lucide-react';
import { cn } from '../../../../utils';

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  onDownload?: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  onClose,
  onDownload,
}) => (
  <div className='absolute top-0 left-0 flex items-center justify-between w-full px-5 py-4 bg-black'>
    <p className='text-white text-lg font-medium'>{title}</p>
    <div className='flex items-center justify-center gap-x-5'>
      {onDownload && (
        <button
          onClick={onDownload}
          className='transition-all duration-300 hover:scale-110 active:scale-95'
        >
          <DownloadIcon size={24} className='text-white' />
        </button>
      )}
      <button
        onClick={onClose}
        className='transition-all duration-300 hover:scale-110 active:scale-95 text-white'
      >
        <X size={24} />
      </button>
    </div>
  </div>
);

const MobileJijelImageModal = () => {
  const { isMobileImageOpen, setIsMobileImageOpen } = useJijelStore();

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/imgs/mainSwiper/jijel_seocho.png';
    link.download = '지젤_라이프그라피_서초_견적서.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (!isMobileImageOpen) return null;

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex flex-col bg-black',
        'transition-opacity duration-300 ease-in-out',
      )}
      onClick={() => setIsMobileImageOpen(false)}
    >
      <ModalHeader
        title='지젤 라이프그라피 서초 견적서'
        onClose={() => setIsMobileImageOpen(false)}
        onDownload={handleDownload}
      />
      <div
        className='flex-1 w-full h-full pt-16'
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src='/imgs/mainSwiper/jijel_seocho.png'
          alt='지젤 라이프그라피 서초 견적서'
          className='w-full h-full object-contain'
          loading='lazy'
        />
      </div>
    </div>
  );
};

export default MobileJijelImageModal;
